import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dialog-max-equipment',
  templateUrl: './dialog-max-equipment.component.html',
  styleUrls: ['./dialog-max-equipment.component.css']
})
export class DialogMaxEquipmentComponent implements OnInit {

  @Output ('close') close: any = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  onClose() {
    this.close.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/plan/dialog-max-equipment/dialog-max-equipment.component.ts